const elements = {
  audioPlayer: null,
  videoPlayer: null,
  currentPlayer: null,
  imagePlayer: null,
  titlePlayer: null,
  artistPlayer: null,
  muteButton: null,
  onMuteButton: null,
  productionSpan: null,
  volumeBar: null,
  volumeFill: null,
  volumeHandle: null,
};

const ahora = new Date();
const horas = ahora.getHours();
const minutos = ahora.getMinutes();
const segundos = ahora.getSeconds();

// Convierte URLs HTTP de streams a HTTPS usando el proxy de WordPress
const getProxiedStreamUrl = (url) => {
  if (!url) return url;
  if (window.location.protocol === "https:" && url.startsWith("http://")) {
    const ajaxUrl =
      typeof tdea_ajax !== "undefined"
        ? tdea_ajax.ajax_url
        : "/wp-admin/admin-ajax.php";
    return `${ajaxUrl}?action=proxy_radio_stream&url=${encodeURIComponent(url)}`;
  }
  return url;
};

// Función para decodificar entidades HTML
const decodeHtmlEntities = (text) => {
  if (!text) return text;

  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};

const initializeElements = () => {
  if (!elements.audioPlayer) {
    elements.audioPlayer = document.getElementById("audioPlayer");
    elements.videoPlayer = document.getElementById("videoPlayer");
    elements.imagePlayer = document.querySelector(".audio-player__image");
    elements.titlePlayer = document.querySelector(".audio-player__title");
    elements.artistPlayer = document.querySelector(".audio-player__artist");
    elements.muteButton = document.querySelector(".audio-player__mute-icon");
    elements.onMuteButton = document.querySelector(
      ".audio-player__onmute-icon",
    );
    elements.productionSpan = document.querySelector(
      ".banner-radio__radio--span--production",
    );
    elements.volumeBar = document.querySelector(".audio-player__volume-bar");
    elements.volumeFill = document.getElementById("volumeFill");
    elements.volumeHandle = document.getElementById("volumeHandle");
    setupEventListeners();
  }
};

const setupEventListeners = () => {
  const toggleMute = () => handlerSound();
  elements.muteButton?.addEventListener("click", toggleMute);
  elements.onMuteButton?.addEventListener("click", toggleMute);

  // Event listeners para el control de volumen
  if (elements.volumeBar) {
    elements.volumeBar.addEventListener("click", handleVolumeBarClick);

    if (elements.volumeHandle) {
      elements.volumeHandle.addEventListener(
        "mousedown",
        handleVolumeHandleMouseDown,
      );
    }
  }
};

const parseTimeString = (timeString) => {
  if (!timeString && timeString !== 0) return null;

  let timeStr;
  if (typeof timeString === "string") {
    timeStr = timeString;
  } else if (typeof timeString === "number") {
    const hours = Math.floor(timeString);
    const minutes = Math.round((timeString - hours) * 60);
    timeStr = `${hours}:${minutes.toString().padStart(2, "0")}`;
  } else if (timeString instanceof Date) {
    timeStr = `${timeString.getHours()}:${timeString
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;
  } else if (typeof timeString === "object" && timeString !== null) {
    if (timeString.inicio_24h) {
      timeStr = timeString.inicio_24h;
    } else if (timeString.inicio) {
      timeStr = timeString.inicio;
    } else if (timeString.timestamp_inicio) {
      const date = new Date(timeString.timestamp_inicio * 1000);
      timeStr = `${date.getHours()}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
    } else {
      console.error(
        "Objeto horario no tiene propiedades reconocidas:",
        timeString,
      );
      return null;
    }
  } else {
    timeStr = String(timeString);
  }

  const cleanTime = timeStr.trim().toLowerCase();

  const hasAmPm = cleanTime.includes("am") || cleanTime.includes("pm");
  const isAm = cleanTime.includes("am");
  const isPm = cleanTime.includes("pm");

  const timeOnly = cleanTime.replace(/(am|pm)/g, "").trim();
  const [hours, minutes] = timeOnly.split(":").map((num) => parseInt(num, 10));

  if (isNaN(hours) || isNaN(minutes)) {
    console.error("Formato de hora inválido:", timeString);
    return null;
  }

  let adjustedHours = hours;

  if (hasAmPm) {
    if (isPm && hours !== 12) {
      adjustedHours += 12;
    } else if (isAm && hours === 12) {
      adjustedHours = 0;
    }
  }

  return { hours: adjustedHours, minutes };
};

const calculateTimeOffset = (horaInicio) => {
  const parsedStartTime = parseTimeString(horaInicio);
  if (!parsedStartTime) {
    console.warn("No se pudo parsear la hora de inicio:", horaInicio);
    return 0;
  }

  const now = new Date();
  const currentHours = now.getHours();
  const currentMinutes = now.getMinutes();
  const currentSeconds = now.getSeconds();

  const startTime = new Date();
  startTime.setHours(parsedStartTime.hours, parsedStartTime.minutes, 0, 0);

  const currentTime = new Date();
  currentTime.setHours(currentHours, currentMinutes, currentSeconds, 0);

  let diffInSeconds = (currentTime - startTime) / 1000;

  if (diffInSeconds < 0) {
    return 0;
  }

  return diffInSeconds;
};

const audioPlayer = (program, horario) => {
  initializeElements();

  if (!program) {
    return;
  }

  const offsetSeconds = calculateTimeOffset(horario);

  updatePlayerElements(program, offsetSeconds);
};

const updatePlayerElements = (program, offsetSeconds = 0) => {
  const { audio: rawAudio, imagen_url, titulo, presentador, type } = program;

  const isLiveProgram = type === "en-vivo" || type === "en vivo";
  // Proxear URL HTTP en páginas HTTPS para evitar Mixed Content
  const audio = isLiveProgram ? getProxiedStreamUrl(rawAudio) : rawAudio;
  const targetPlayer = isLiveProgram
    ? elements.videoPlayer
    : elements.audioPlayer;
  const otherPlayer = isLiveProgram
    ? elements.audioPlayer
    : elements.videoPlayer;
  elements.currentPlayer = targetPlayer;

  if (targetPlayer && audio) {
    if (otherPlayer) {
      otherPlayer.pause();
      otherPlayer.src = "";
      otherPlayer.load();
    }

    if (!audio || audio.trim() === "") {
      return;
    }

    if (isLiveProgram) {
      targetPlayer.innerHTML = "";

      const source = document.createElement("source");
      source.src = audio;
      source.type = "audio/mpeg";

      targetPlayer.controls = true;
      targetPlayer.autoplay = true;
      targetPlayer.muted = false;
      targetPlayer.setAttribute("name", "media");

      targetPlayer.appendChild(source);
      targetPlayer.load();
    } else {
      targetPlayer.innerHTML = "";
      targetPlayer.src = audio;
      targetPlayer.controls = false;
      targetPlayer.autoplay = true;
      targetPlayer.loop = true;
      targetPlayer.muted = true;
      targetPlayer.load();
    }

    targetPlayer.addEventListener(
      "error",
      (e) => {
        if (targetPlayer.error) {
          switch (targetPlayer.error.code) {
            case targetPlayer.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
              if (isLiveProgram) {
                handleLiveStreamEmbed(audio);
                return;
              }
              break;
          }
        }

        toggleButtonVisibility(true);
      },
      { once: true },
    );

    targetPlayer.addEventListener(
      "loadedmetadata",
      () => {
        if (
          !isLiveProgram &&
          offsetSeconds > 0 &&
          offsetSeconds < targetPlayer.duration
        ) {
          targetPlayer.currentTime = offsetSeconds;
        }

        // Inicializar volumen al 70%
        targetPlayer.volume = 0.7;
        updateVolumeUI(70);

        targetPlayer
          .play()
          .then(() => {
            if (!isLiveProgram) {
              targetPlayer.muted = false;
            }
            toggleButtonVisibility(false);
          })
          .catch((error) => {
            if (!isLiveProgram) {
              targetPlayer.muted = true;
            }
            toggleButtonVisibility(true);
          });
      },
      { once: true },
    );

    // Event listener para cuando termina el audio (contenido de relleno)
    targetPlayer.addEventListener("ended", () => {
      console.log("🎵 Audio terminado, cargando siguiente contenido...");
      // Recargar la parrilla para obtener el siguiente contenido
      if (window.reloadRadioSchedule) {
        window.reloadRadioSchedule();
      }
    });
  }

  if (elements.imagePlayer) {
    const defaultImage =
      typeof tdea_ajax !== "undefined" && tdea_ajax.theme_url
        ? `${tdea_ajax.theme_url}assets/logo-tdea-radio.svg`
        : `${window.location.origin}/wp-content/themes/TdeA/assets/logo-tdea-radio.svg`;

    elements.imagePlayer.src = imagen_url || defaultImage;
    if (titulo) elements.imagePlayer.alt = titulo;
  }

  if (elements.titlePlayer && titulo) {
    elements.titlePlayer.textContent = decodeHtmlEntities(titulo);
  }

  if (elements.artistPlayer && presentador) {
    elements.artistPlayer.textContent = decodeHtmlEntities(presentador);
  }

  if (elements.productionSpan && titulo) {
    elements.productionSpan.textContent = decodeHtmlEntities(titulo);
  }
};

const handlerSound = () => {
  const { currentPlayer, muteButton, onMuteButton } = elements;

  if (!currentPlayer) {
    return;
  }

  const isMuted = currentPlayer.muted;
  const isPaused = currentPlayer.paused;

  currentPlayer.muted = !isMuted;

  if (isPaused) {
    currentPlayer
      .play()
      .then(() => {})
      .catch((error) => {});
  }

  toggleButtonVisibility(!isMuted);
};

const toggleButtonVisibility = (showMuteButton) => {
  const { muteButton, onMuteButton } = elements;

  if (muteButton && onMuteButton) {
    muteButton.style.display = showMuteButton ? "block" : "none";
    onMuteButton.style.display = showMuteButton ? "none" : "block";
  }
};

// Función para manejar embeds de listen2myradio cuando el video player falla
const handleLiveStreamEmbed = (url) => {
  // Buscar un contenedor donde insertar el reproductor alternativo
  const playerContainer = document.querySelector(".audio-player");
  if (!playerContainer) {
    return;
  }

  // Remover reproductor alternativo anterior si existe
  const existingAltPlayer = document.getElementById("alternativeStreamPlayer");
  if (existingAltPlayer) {
    existingAltPlayer.remove();
  }

  // Verificar si es un stream directo (como Icecast/Shoutcast)
  if (url.includes("/stream") || url.includes(":")) {
    // Crear un audio element con configuración especial para streams
    const altAudio = document.createElement("audio");
    altAudio.id = "alternativeStreamPlayer";
    altAudio.style.display = "none";
    altAudio.crossOrigin = "anonymous";
    altAudio.preload = "none";
    altAudio.controls = false;

    // Configurar source con tipo MIME específico para streams
    const source = document.createElement("source");
    source.src = url;
    source.type = "audio/mpeg"; // Tipo común para streams de radio
    altAudio.appendChild(source);

    // Agregar el reproductor alternativo
    playerContainer.appendChild(altAudio);

    // Actualizar la referencia del reproductor actual
    elements.currentPlayer = altAudio;

    // Intentar reproducir
    altAudio.load();
    altAudio
      .play()
      .then(() => {
        altAudio.muted = false;
        toggleButtonVisibility(false);
      })
      .catch((error) => {
        // Como último recurso, crear iframe
        createIframeEmbed(url, playerContainer);
      });
  } else {
    // Para URLs de listen2myradio u otros embeds, usar iframe
    createIframeEmbed(url, playerContainer);
  }
};

// Función auxiliar para crear iframe embed
const createIframeEmbed = (url, container) => {
  const iframe = document.createElement("iframe");
  iframe.src = url;
  iframe.style.display = "none";
  iframe.style.width = "100%";
  iframe.style.height = "0";
  iframe.allow = "autoplay";
  iframe.id = "liveStreamEmbed";

  container.appendChild(iframe);
  toggleButtonVisibility(false);
};

// Funciones para el control de volumen
const updateVolumeUI = (volumePercent) => {
  if (elements.volumeFill && elements.volumeHandle) {
    elements.volumeFill.style.width = `${volumePercent}%`;
    elements.volumeHandle.style.left = `${volumePercent}%`;
  }
};

const setVolume = (volumePercent) => {
  if (!elements.currentPlayer) return;

  const volume = Math.max(0, Math.min(100, volumePercent)) / 100;
  elements.currentPlayer.volume = volume;
  updateVolumeUI(volumePercent);

  // Si el volumen es mayor a 0, quitar mute automáticamente
  if (volume > 0 && elements.currentPlayer.muted) {
    elements.currentPlayer.muted = false;
    toggleButtonVisibility(false);
  }

  // Si el volumen es 0, activar mute
  if (volume === 0 && !elements.currentPlayer.muted) {
    elements.currentPlayer.muted = true;
    toggleButtonVisibility(true);
  }
};

const handleVolumeBarClick = (e) => {
  if (!elements.volumeBar) return;

  const rect = elements.volumeBar.getBoundingClientRect();
  const clickX = e.clientX - rect.left;
  const volumePercent = (clickX / rect.width) * 100;

  setVolume(volumePercent);
};

const handleVolumeHandleMouseDown = (e) => {
  e.preventDefault();

  const handleMouseMove = (moveEvent) => {
    if (!elements.volumeBar) return;

    const rect = elements.volumeBar.getBoundingClientRect();
    const moveX = moveEvent.clientX - rect.left;
    const volumePercent = (moveX / rect.width) * 100;

    setVolume(volumePercent);
  };

  const handleMouseUp = () => {
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  document.addEventListener("mousemove", handleMouseMove);
  document.addEventListener("mouseup", handleMouseUp);
};

export { audioPlayer, handlerSound };
